import { createAuthClient } from 'better-auth/react';
import { adminClient } from 'better-auth/client/plugins';
import { ac, admin, manager, qa, agent } from './permissions';

export const authClient = createAuthClient({
  plugins: [
    adminClient({
      ac,
      roles: { admin, manager, qa, agent },
    }),
  ],
});
